/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * 全局共享数据，初始化全局配置
 */
import { InjectionKey } from 'vue';
import { webview } from '@kk/utils';

type listenerParamType = { passive: true } | false;

let listenerParam: listenerParamType = false;

try {
  const opts = Object.defineProperty({}, 'passive', {
    get: function () {
      listenerParam = { passive: true };
      return true;
    }
  });
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  addEventListener('test', () => {}, opts);
} catch (e) {
  listenerParam = false;
}

/**
 * 全局共享数据
 */
export interface globalDataType {
  listenerParam: listenerParamType;
  /**
   * 快看APP内返回true
   */
  isKuaikan: boolean;
  visitsource: number;
}

export const globalData = {
  listenerParam,
  isKuaikan: webview.isKuaikan,
  visitsource: Number(window.getQuery('visitsource') || 0)
} as globalDataType;

export const globalDataKey = Symbol(
  'golobalDataKey'
) as InjectionKey<globalDataType>;
